import axios from "axios";

export const CreateQuestionApi = async (question, token) => {
  try {
    const BASED_URL = process.env.REACT_APP_BASED_URL;
    const path = "/admin/question/create?";
    const endpoint = `${BASED_URL}${path}token=${token}`;

    const response = await axios.post(endpoint, question);

    return response;
  } catch (error) {
    return error.response;
  }
};

export default CreateQuestionApi;
